import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../hooks';
import { ConfigPanelGroup } from '../components/ConfigPanelGroup';
import { ConfigPanelDeviceRow } from '../components/ConfigPanelDeviceRow';
import { DialogPanelGroupEdit } from '../components/DialogPanelGroupEdit';
import { DialogPanelTransmitterEdit } from '../components/DialogPanelTransmitterEdit';
import { newPanelTransmitter } from '../actions/NewPanelTransmitter';
import { newPanelGroup } from '../actions/NewPanelGroup';
import { allPanelGroups } from '../features/panel_groups/panelGroupsSlice';
import { panelDevicesInGroup } from '../features/panel_devices/panelDevicesSlice';
const ConfigPanelGroupRows = (props) => {
    const panel_devices = useAppSelector(state => panelDevicesInGroup(state.definitions.panel_devices, props.panel_group_id));
    const rows = [];
    for (const pd of panel_devices) {
        rows.push(_jsx(ConfigPanelDeviceRow, { id: pd.id }, 'pt' + pd.id));
    }
    return (_jsxs(_Fragment, { children: [" ", rows, " "] }));
};
export const ConfigPanel = (_props) => {
    const { id } = useParams();
    const panel_id = Number(id);
    const dispatch = useAppDispatch();
    const newGroup = () => dispatch(newPanelGroup(panel_id));
    const newTransmitter = () => dispatch(newPanelTransmitter());
    const panel_groups = useAppSelector(state => allPanelGroups(state.definitions.panel_groups));
    const groups = [];
    for (const panel_group of panel_groups) {
        if (panel_group.panel_id == panel_id) {
            groups.push(panel_group.id);
        }
    }
    const rows = [];
    for (const group_id of groups) {
        rows.push(_jsx(ConfigPanelGroup, { id: group_id }, 'g' + group_id));
        rows.push(_jsx(ConfigPanelGroupRows, { panel_group_id: group_id }, group_id));
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx(DialogPanelGroupEdit, { panel_id: panel_id }), _jsx(DialogPanelTransmitterEdit, { panel_id: panel_id }), _jsx("div", { className: "operations", children: _jsxs("div", { children: [_jsx("button", { className: "lw success", onClick: newGroup, children: "\u00A0L\u00E4gg till grupp...\u00A0" }), ' ', _jsx("button", { className: "lw success", onClick: newTransmitter, children: "\u00A0L\u00E4gg till kontakt...\u00A0" })] }) }), _jsx("div", { className: "config-rows config-panel-device", children: rows })] }));
};
